export default "__VITE_ASSET__f7d027b8__"